<template>
  <div class="introduce-page">
    <div class="ai-video">
      <!-- <img class="poster" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/ai-001.jpg"> -->
      <img class="aotoAll" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00133.gif">
    </div>
    <div class="video-head">
      <div class="aiVideo">
        <img style="width: 100%;" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00134.png" @click="app.module.video.play('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00135.mp4')">
        <!-- <video
          width="335"
          height="188" 
          controls 
          x5-video-player-type="h5"
          x-webkit-airplay="true"
          x5-video-orientation="portraint"
          x5-video-player-fullscreen="portraint"
          x5-video-ignore-metadata='true'
          src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00135.mp4"
          loop
          poster="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00134.png"
        >
          你的浏览器不支持video标签
        </video> -->
      </div>
    </div>
    <div class="commen-img"><img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/ai-004.png" ></div>
    <div class="swiper-info">
      <swiper class="swiper" :options="swiperOption" ref="mySwiper">
        <swiper-slide
          v-for="list in swiperList"
          :key="list.tit"
        >
          <div class=swiperTop></div>
          <div class="swiperTit">{{ list.tit }}</div>
          <div class="swiperImg"><img :src="list.src" ></div>
          <div class="swiperText">{{ list.content }}</div>
          <div class="swiperBtn" @click="detailConsult">咨询了解</div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="teacher">
      <div class="commen-img"><img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/ai-005.png" ></div>
      <img class="teacherImg" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/ai-011.png" >
      <div class="teacherTit">让老师更专注于教学本身</div>
      <div class="teacherVal">通过AI的能力帮助老师快速为学员撰写课堂评价和阶段性总结，同时不再依赖老师的文字水平。工作效率提升，大大减轻老师的工作负担，使他们能够更专注于教学本身。</div>
      <div class="commen-img"><img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/ai-006.png" ></div>
      <img class="teacherImg" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/ai-012.png" >
      <div class="teacherTit">让家长参与孩子成长</div>
      <div class="teacherVal">通过AI识别的能力，可自动生成孩子的成长相册和作品集，机构服务更系统化。家长能全面了解孩子的成长过程，随时随地分享孩子的成长。提升家长在孩子成长过程中的参与感和了解度。</div>
    </div>
    <div class="bottomFixed">
      <div class="borderTop"></div>
      <div class="btn" @click="detailConsult">咨询了解</div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import "swiper/dist/css/swiper.css";

export default {
  name: 'course-comment-introduce',
  data() {
    return {
      pageTitle: '成长粒介绍',
      swiperOption: {
        effect: 'coverflow',
        centeredSlides: true,
        spaceBetween: '12%',
        slidesPerView: 'auto',
        loop: true,
        autoplay: {
          delay: 5000
        }, // 是否自动播放
        speed: 1000,
        touchRatio: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2,
          slideShadows: false,
        },
        pagination: { // 分页器
          el: '.swiper-pagination'
        },
      },
      swiperList: [
        {
          tit: '机构服务力增值',
          src: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/ai-007.png',
          content: '通过AI能力提高日常服务内容的制作效率。帮助老师制作阶段性服务总结的内容，使其更加全面和有条理。支持素材的归类管理，让服务更加丰富、精细，更好地传播。'
        },
        {
          tit: '管理资产增值',
          src: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/ai-008.png',
          content: '支持素材多维度分类汇总，机构统一管理。通过互动数据分析，提升服务质量，选出最佳资源，发现出色的老师。'
        },
        {
          tit: '服务口碑增值',
          src: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/ai-009.png',
          content: '支持素材增加水印，方便机构服务内容自传播，提高机构口碑价值，从而带来更多新的线索和复购机会。'
        },
        {
          tit: '私域经营增值',
          src: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/ai-010.png',
          content: '通过用户互动数据分析，发现潜在价值客户和问题客户，帮助机构有针对性地进行相关策略的制定和执行，从而在营销、服务和续费等多个环节上实现精准运营。'
        }
      ],
      loadState: false,
    }
  },
  methods: {
    async detailConsult() {
      if (this.loadState) return
      this.loadState = true
      try {
        await this.$api.appStoreOpen({
          appStoreCode: 'AI_GROWTH'
        });
        vant.Dialog.alert({
          message: '非常感谢您的咨询申请，我们的客户经理将尽快与您取得联系。',
        })
      } catch (error) {
        console.log(error)
      }
      this.loadState = false
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
}
</script>

<style lang="scss" scoped>
.swiper-container {
  width: 375px;
  overflow: visible!important;
  .swiper-pagination {
    bottom: -35px;
    /deep/ .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
    }
    /deep/ .swiper-pagination-bullet-active {
      width: 20px;
      height: 6px;
      background: #8070F5;
      border-radius: calc(var(--gap) * 3) ;
    }
  }
}
.swiper-slide {
  width: 335px;
  height: 486px;
  background: var(--white);
  box-shadow: 0px 10px 30px -5px rgba(6,29,84,0.1);
  border-radius: calc(var(--gap) * 8);
}
.introduce-page {
  font-family: PingFang SC, PingFang SC;
  background: var(--g1);
  .bottomFixed {
    width: 100%;
    height: 52px;
    position: sticky;
    bottom: 0;
    left: 0;
    z-index: 66;
    border-top: 1px var(--g3) solid;
    background: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      width: 343px;
      height: 40px;
      background: #8070F5;
      border-radius: calc(var(--gap) * 8);
      text-align: center;
      line-height: 40px;
      font-size: var(--fs-lg);
      font-weight: 400;
      color: #FFFFFF;
    }
  }
  .ai-video {
    position: relative;
    background: var(--white);
    // z-index: 1;
    // .poster {
    //   width: 100%;
    //   // height: 490px;
    //   position: absolute;
    //   z-index: -1;
    // }
    .aotoAll {
      width: 100%;
      min-height: 490px;
    }
    // .posterDiv {
    //   width: 100%;
    //   height: 320px;
    // }
    // .aiImg {
    //   position: absolute;
    //   width: 60px;
    //   height: 60px;
    //   left: 50%;
    //   margin: -30px 0 0 -30px;
    //   top: 50%;
    // }
  }
  .video-head {
    background: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 270px;
    .aiVideo {
      width: 335px;
      height: 188px;
      box-shadow: 0px 3px 14px -3px rgba(6,29,84,0.2);
      // border-radius: calc(var(--gap) * 8);
      // video {
      //   border-radius: calc(var(--gap) * 8);
      // }
    }
  }
  .commen-img {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 50px;
    }
  }
  .my-swiper .van-swipe-item {
    color: #fff;
    font-size: var(--lh-md);
    line-height: 150px;
    text-align: center;
  }
  .swiper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .teacher {
    margin-top: 62px;
    background: var(--white);
    text-align: center;
    padding-bottom: calc(var(--gap) * 6);
    .teacherImg {
      width: 335px;
      height: 251px;
    }
    .teacherTit {
      font-size: var(--lh-sm);
      font-weight: 600;
      color: var(--g8);
      line-height: 21px;
      margin-top: calc(var(--gap) * 9);
    }
    .teacherVal {
      width: 311px;
      height: 80px;
      font-size: var(--fs-md);
      font-weight: 400;
      color: var(--g7);
      line-height: 20px;
      margin: calc(var(--gap) * 10) auto calc(var(--gap) * 52);
      text-align: start;
    }
  }
  .swiperTop {
    width: 48px;
    height: 4px;
    margin: 0 auto 28px;
    background: #8070F5;
    border-radius: 0 0 calc(var(--gap) * 2) calc(var(--gap) * 2);
  }
  .swiperTit {
    font-size:  var(--lh-sm);
    font-weight: 600;
    color: var(--g8);
    text-align: center;
  }
  .swiperImg, .swiperImg img {
    width: 295px;
    height: 221px;
  }
  .swiperImg {
    margin: var(--lh-md) auto var(--lh-ex1);
  }
  .swiperText {
    width: 271px;
    font-size: var(--fs-md);
    font-weight: 400;
    color: var(--g7);
    line-height: var(--lh-sm);
    margin: 0 auto var(--lh-ex1);
  }
  .swiperBtn {
    width: 128px;
    height: 36px;
    background: linear-gradient(262deg, #A863FF 0%, #5B32FF 100%);
    border-radius: var(--lh-md);
    font-size: var(fs-lg);
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 36px;
    margin: auto;
  }
}
</style>